
import { Notyf } from "notyf"

export function byId(id) {
  return document.getElementById(id)
}

export function tag(name, attrs, content, ...children) {
  const element = document.createElement(name)
  for (const key in attrs) {
    if (key === "class") {
      element.classList.add(attrs[key])
    }
    element.setAttribute(key, attrs[key])
  }
  element.textContent = content
  for (const child of children) {
    element.appendChild(child)
  }
  return element
}

export function bindData(data, root) {
  let elements = Array.from(root.querySelectorAll('[data-field]'))
  if (root.dataset && root.dataset.field) elements.push(root)
  for (const element of elements) {
    let value = data[element.dataset.field]
    if (element.dataset.type === 'date') {
      value = value ? new Date(value).toLocaleString() : "N/A"
    }
    if (element.tagName === 'INPUT') {
      element.value = value
    } else {
      element.textContent = value
    }
  }

  elements = Array.from(root.querySelectorAll('[data-class-field]'))
  if (root.dataset && root.dataset.classField) elements.push(root)
  for (const element of elements) {
    const classField = element.dataset.classField
    if (classField) {
      if (element.dataset.classFieldRemove) {
        element.classList.remove(element.dataset.classFieldRemove)
      }
      element.classList.add(data[classField].toLowerCase())
      element.dataset.classFieldRemove = data[classField].toLowerCase()
    }
  }
}

/**
 * Distance between two coordinate points in latitude, longitude
 * @param {*} lat1 (lat.min)
 * @param {*} lon1 (lon.min)
 * @param {*} lat2 (lat.max)
 * @param {*} lon2 (lon.max)
 * @returns distance in meters
 */
 export function measure(lat1, lon1, lat2, lon2) {  // generally used geo measurement function
  var R = 6378.137; // Radius of earth in KM
  var dLat = lat2 * Math.PI / 180 - lat1 * Math.PI / 180;
  var dLon = lon2 * Math.PI / 180 - lon1 * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d * 1000; // meters
}

export function slantDistance(remote, local) {
  const lat1 = remote.position.latitude
  const lon1 = remote.position.longitude
  const lat2 = local.position.latitude
  const lon2 = local.position.longitude
  const alt1 = remote.position.gnssAltitude
  const alt2 = local.position.gnssAltitude
  
  const dist = measure(lat1, lon1, lat2, lon2)

  const hypotenuse = Math.sqrt(Math.pow(dist, 2) + Math.pow(alt2 - alt1, 2))

  return Math.round(hypotenuse)
}

export const notyf = new Notyf({
  position: {
    x: 'right',
    y: 'top',
  },
  duration: 3000,
  types: [
    {
      type: 'error',
      dismissible: true,
      duration: 30000,
    }
  ]
})

export function formatNumber(number, fractionDigits) {
  return new Intl.NumberFormat(undefined, { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(number)
}